import { timeStringToMs } from '../../utility/DateFormatter';
import { IAssetDetail, IAssetStream, IAssetSummary, ICredit } from '../../../api/models/AndromeTV.types';

export class VodAsset implements IAssetDetail {
  constructor(asset: IAssetDetail) {
    // Object.assign(this, asset); //TODO find a way to do this without manually having to copy every member and still have jsdoc not complain
    this.id = asset.id;
    this.type = asset.type;
    this.title = asset.title;
    this.originalTitle = asset.originalTitle;
    this.shortSynopsis = asset.shortSynopsis;
    this.longSynopsis = asset.longSynopsis;
    this.posterImage = asset.posterImage;
    this.boxcoverImage = asset.boxcoverImage;
    this.wallpaperImage = asset.wallpaperImage;
    this.adult = asset.adult;
    this.minimumAge = asset.minimumAge;
    this.parentalRatings = asset.parentalRatings;
    this.duration = asset.duration;
    this.episode = asset.episode;
    this.season = asset.season;
    this.seasonId = asset.seasonId;
    this.seriesId = asset.seriesId;
    this.credits = asset.credits;
    this.productionYear = asset.productionYear;
    this.productionLocations = asset.productionLocations;
    this.nextEpisode = asset.nextEpisode;
    this.tags = asset.tags;
    this.genres = asset.genres;
    this.streams = asset.streams;
    this.seasons = asset.seasons;
    this.episodes = asset.episodes;
    this.validFrom = asset.validFrom;
    this.validUntil = asset.validUntil;
    this.score = asset.score;
    this.operatorScore = asset.operatorScore;
    this.catalogs = asset.catalogs;
  }

  id: string;
  type: string;
  title: string;
  originalTitle?: string | undefined;
  shortSynopsis?: string | undefined;
  longSynopsis?: string | undefined;
  posterImage?: string | undefined;
  boxcoverImage?: string | undefined;
  wallpaperImage?: string | undefined;
  adult?: boolean | undefined;
  minimumAge?: number | undefined;
  parentalRatings?: string[] | undefined;
  duration?: number | undefined;
  episode?: number | undefined;
  season?: number | undefined;
  seasonId?: string | undefined;
  seriesId?: string | undefined;
  credits?: ICredit[] | undefined;
  productionYear?: number | undefined;
  productionLocations?: string[] | undefined;
  nextEpisode?: string | undefined;
  tags?: string[] | undefined;
  genres?: string[] | undefined;
  streams?: IAssetStream[] | undefined;
  seasons?: IAssetSummary[] | undefined;
  episodes?: IAssetSummary[] | undefined;
  validFrom?: string | undefined;
  validUntil?: string | undefined;
  score?: number | undefined;
  operatorScore?: number | undefined;
  catalogs?: string[] | undefined;

  isExpired() {
    const now = new Date().getTime();
    const from = this.validFrom ? timeStringToMs(this.validFrom) : undefined;
    const until = this.validUntil ? timeStringToMs(this.validUntil) : undefined;
    return from && until && (until < now || from > now);
  }
}
